export const makeMenuItemKey = (id: number) => `menuItem-${id}`;
